/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.9.0 (NJsonSchema v10.4.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
    private readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        options.headers = {
            ...options.headers,
            Authorization: "Bearer " + this.config.token,
        };
        return Promise.resolve(options);
    };
}

export interface IClient {
    /**
     * Download an item by path
     * @param filePath (optional) 
     * @param originalFileName (optional) 
     */
    attachment_Download(filePath: string | null | undefined, originalFileName: string | null | undefined): Promise<SwaggerResponse<void>>;
    /**
     * Upload an item
     * @param file_ContentType (optional) 
     * @param file_ContentDisposition (optional) 
     * @param file_Headers (optional) 
     * @param file_Length (optional) 
     * @param file_Name (optional) 
     * @param file_FileName (optional) 
     * @param siteSurveyId (optional) 
     */
    attachment_Upload(file_ContentType: string | null | undefined, file_ContentDisposition: string | null | undefined, file_Headers: IHeaderDictionary | null | undefined, file_Length: number | undefined, file_Name: string | null | undefined, file_FileName: string | null | undefined, siteSurveyId: string | null | undefined): Promise<SwaggerResponse<CommandResponse>>;
    /**
     * Upload multiple files
     * @param files (optional) 
     * @param siteSurveyId (optional) 
     */
    attachment_UploadMultiple(files: FileParameter[] | null | undefined, siteSurveyId: string | null | undefined): Promise<SwaggerResponse<CommandResponse2>>;
    /**
     * Get all definitions
     */
    definition_GetAll(): Promise<SwaggerResponse<DefinitionSummaryModel[]>>;
    /**
     * Create a definition
     */
    definition_Create(command: CreateDefinitionCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Get a definition by id
     */
    definition_Get(id: string | null): Promise<SwaggerResponse<DefinitionModel>>;
    /**
     * Update a definition
     */
    definition_Update(id: string | null, command: UpdateDefinitionCommand): Promise<SwaggerResponse<void>>;
    /**
     * Soft-delete a definition
     */
    definition_Delete(id: string | null): Promise<SwaggerResponse<void>>;
    /**
     * Get audit history of a definition by id
     */
    definition_GetAuditHistory(id: string | null): Promise<SwaggerResponse<DefinitionAuditModel[]>>;
    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) Definition Name
     */
    definition_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * Get all labor types
     */
    laborType_GetAll(): Promise<SwaggerResponse<LaborTypeSummaryModel[]>>;
    /**
     * Create a labor type
     */
    laborType_Create(command: CreateLaborTypeCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Get a labor type by id
     */
    laborType_Get(id: string | null): Promise<SwaggerResponse<LaborTypeModel>>;
    /**
     * Update a labor type
     */
    laborType_Update(id: string | null, command: UpdateLaborTypeCommand): Promise<SwaggerResponse<void>>;
    /**
     * Soft-delete a labor type
     */
    laborType_Delete(id: string | null): Promise<SwaggerResponse<void>>;
    /**
     * Get audit history of a labor type by id
     */
    laborType_GetAuditHistory(id: string | null): Promise<SwaggerResponse<LaborTypeAuditModel[]>>;
    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) LaborType Name
     */
    laborType_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * Get all records
     */
    maintenanceSchedule_GetAll(): Promise<SwaggerResponse<MaintenanceScheduleSummaryModel[]>>;
    /**
     * Get an item by id
     */
    maintenanceSchedule_Get(id: string | null): Promise<SwaggerResponse<MaintenanceScheduleModel>>;
    /**
     * Update an item
     */
    maintenanceSchedule_Update(id: string | null, command: UpdateMaintenanceScheduleCommand): Promise<SwaggerResponse<void>>;
    /**
     * Soft-delete an item
     */
    maintenanceSchedule_Delete(id: string | null): Promise<SwaggerResponse<void>>;
    /**
     * Get an item by id
     */
    maintenanceSchedule_GetFlatList(id: string | null): Promise<SwaggerResponse<MaintenanceScheduleFlatListModel>>;
    /**
     * Create an item
     */
    maintenanceSchedule_Create(command: GenerateMaintenanceScheduleCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param siteSurveyId (optional) Id of the site survey that owns the schedule(s)
     * @param nameFilter (optional) MaintenanceSchedule Name
     */
    maintenanceSchedule_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, siteSurveyId: string | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * Get audit history of an item by id
     */
    maintenanceSchedule_GetAuditHistory(id: string | null): Promise<SwaggerResponse<MaintenanceScheduleAuditModel[]>>;
    /**
     * Get all records
     */
    maintenanceSheet_GetAll(): Promise<SwaggerResponse<MaintenanceSheetSummaryModel[]>>;
    /**
     * Get an item by id
     */
    maintenanceSheet_Get(id: string | null): Promise<SwaggerResponse<MaintenanceSheetModel>>;
    /**
     * Update an item
     */
    maintenanceSheet_Update(id: string | null, command: UpdateMaintenanceSheetCommand): Promise<SwaggerResponse<void>>;
    /**
     * Soft-delete an item
     */
    maintenanceSheet_Delete(id: string | null): Promise<SwaggerResponse<void>>;
    /**
     * Generate an item
     */
    maintenanceSheet_Create(command: GenerateMaintenanceSheetCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Complete an item
     */
    maintenanceSheet_Fulfill(id: string | null, command: FulfillMaintenanceSheetCommand): Promise<SwaggerResponse<void>>;
    /**
     * Complete an item
     */
    maintenanceSheet_Complete(id: string | null, command: CompleteMaintenanceSheetCommand): Promise<SwaggerResponse<void>>;
    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param maintenanceScheduleId (optional) Id of the maintenance schedule that the sheets are generated from
     * @param nameFilter (optional) MaintenanceSheet Name
     */
    maintenanceSheet_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, maintenanceScheduleId: string | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * Get audit history of an item by id
     */
    maintenanceSheet_GetAuditHistory(id: string | null): Promise<SwaggerResponse<MaintenanceSheetAuditModel[]>>;
    /**
     * Get all records
     */
    recommissionSheet_GetAll(): Promise<SwaggerResponse<RecommissionSheetSummaryModel[]>>;
    /**
     * Get an item by id
     */
    recommissionSheet_Get(id: string | null): Promise<SwaggerResponse<RecommissionSheetModel>>;
    /**
     * Update an item
     */
    recommissionSheet_Update(id: string | null, command: UpdateRecommissionSheetCommand): Promise<SwaggerResponse<void>>;
    /**
     * Soft-delete an item
     */
    recommissionSheet_Delete(id: string | null): Promise<SwaggerResponse<void>>;
    /**
     * Generate an item
     */
    recommissionSheet_Create(command: GenerateRecommissionSheetCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Complete an item
     */
    recommissionSheet_Fulfill(id: string | null, command: FulfillRecommissionSheetCommand): Promise<SwaggerResponse<void>>;
    /**
     * Complete an item
     */
    recommissionSheet_Complete(id: string | null, command: CompleteRecommissionSheetCommand): Promise<SwaggerResponse<void>>;
    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param siteSurveyId (optional) Id of the site survey that the sheets are generated from
     * @param nameFilter (optional) RecommissionSheet Name
     */
    recommissionSheet_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, siteSurveyId: string | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * Get audit history of an item by id
     */
    recommissionSheet_GetAuditHistory(id: string | null): Promise<SwaggerResponse<RecommissionSheetAuditModel[]>>;
    /**
     * Get all site records
     */
    site_GetAll(): Promise<SwaggerResponse<SiteSummaryModel[]>>;
    /**
     * Create a Site
     */
    site_Create(command: CreateSiteCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Get an item by id
     */
    site_Get(id: string | null): Promise<SwaggerResponse<SiteModel>>;
    /**
     * Update an item
     */
    site_Update(id: string | null, command: UpdateSiteCommand): Promise<SwaggerResponse<void>>;
    /**
     * Soft-delete an item
     */
    site_Delete(id: string | null): Promise<SwaggerResponse<void>>;
    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) SiteSurvey Name
     */
    site_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * Get all records
     */
    siteSurvey_GetAll(): Promise<SwaggerResponse<SiteSurveySummaryModel[]>>;
    /**
     * Create an item
     */
    siteSurvey_Create(command: CreateSiteSurveyCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Get an item by id
     */
    siteSurvey_Get(id: string | null): Promise<SwaggerResponse<SiteSurveyModel>>;
    /**
     * Update an item
     */
    siteSurvey_Update(id: string | null, command: UpdateSiteSurveyCommand): Promise<SwaggerResponse<void>>;
    /**
     * Get a preview of the recommission sheet for a given survey
     */
    siteSurvey_GetRecommissionSheetFlatListPreview(id: string | null): Promise<SwaggerResponse<SiteSurveyRecommissionSheetPreviewModel>>;
    /**
     * Get all the node locations in the survey
     */
    siteSurvey_GetPaths(id: string | null): Promise<SwaggerResponse<string[]>>;
    /**
     * Get all the node summary in the survey
     */
    siteSurvey_GetNodeSummaryList(id: string | null): Promise<SwaggerResponse<NodeSummary[]>>;
    /**
     * Clone an item
     */
    siteSurvey_Clone(command: CloneSiteSurveyCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Complete an item
     */
    siteSurvey_Complete(id: string | null, command: CompleteSiteSurveyCommand): Promise<SwaggerResponse<void>>;
    /**
     * Update an item
     */
    siteSurvey_Fulfill(id: string | null, command: FulfillSiteSurveyCommand): Promise<SwaggerResponse<void>>;
    /**
     * Search
     * @param siteId (optional) The site identifier.
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) SiteSurvey Name
     */
    siteSurvey_Search(siteId: string | null | undefined, start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * Soft-delete an item
     * @param siteId (optional) 
     */
    siteSurvey_Delete(siteId: string | null | undefined, siteSurveyId: string | null): Promise<SwaggerResponse<void>>;
    /**
     * Get audit history of an item by id
     */
    siteSurvey_GetAuditHistory(id: string | null): Promise<SwaggerResponse<SiteSurveyAuditModel[]>>;
    /**
     * Validate that the user account is valid and return an auth token
    to the requesting app for use in the api.
     */
    user_Authenticate(command: AuthenticateCommand): Promise<SwaggerResponse<TokenResponse>>;
    /**
     * Validate that the user account is valid and return an auth token
    to the requesting app for use in the api.
     */
    user_RefreshToken(command: RefreshTokenCommand): Promise<SwaggerResponse<TokenResponse>>;
    /**
     * Get all
     */
    user_GetAll(): Promise<SwaggerResponse<UserSummaryModel[]>>;
    /**
     * Create a user
     */
    user_Create(command: CreateUserCommand): Promise<SwaggerResponse<CreateResponse>>;
    /**
     * Update a user.
    Only admin can update a user.
     */
    user_Update(id: string | null, command: UpdateUserCommand): Promise<SwaggerResponse<void>>;
    /**
     * Get an item by id
     */
    user_Get(id: string | null): Promise<SwaggerResponse<UserModel>>;
    /**
     * Deactivate/Soft-delete a user
     */
    user_Delete(id: string): Promise<SwaggerResponse<void>>;
    /**
     * Search
     * @param filter (optional) Filter
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     */
    user_Search(filter: string | null | undefined, start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined): Promise<SwaggerResponse<DataTablesResponse>>;
    /**
     * SetPassword for the first time with token
     */
    user_SetPassword(command: SetPasswordCommand): Promise<SwaggerResponse<IdentityResult>>;
    /**
     * ChangePassword
     */
    user_ChangePassword(command: ChangePasswordCommand): Promise<SwaggerResponse<IdentityResult>>;
    /**
     * Allow the user to request an email with password reset link.
     */
    user_ForgotPassword(command: ForgotPasswordCommand): Promise<SwaggerResponse<void>>;
    /**
     * ResetPassword
     */
    user_ResetPassword(command: ResetPasswordCommand): Promise<SwaggerResponse<IdentityResult>>;
}

export class Client extends AuthorizedApiBase implements IClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        //this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://insite-api-staging.azurewebsites.net";
        //this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44358";
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://kalderinsiteapi.azurewebsites.net";
    }

    /**
     * Download an item by path
     * @param filePath (optional) 
     * @param originalFileName (optional) 
     */
    attachment_Download(filePath: string | null | undefined, originalFileName: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Attachment/Download?";
        if (filePath !== undefined && filePath !== null)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        if (originalFileName !== undefined && originalFileName !== null)
            url_ += "originalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachment_Download(_response);
        });
    }

    protected processAttachment_Download(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Upload an item
     * @param file_ContentType (optional) 
     * @param file_ContentDisposition (optional) 
     * @param file_Headers (optional) 
     * @param file_Length (optional) 
     * @param file_Name (optional) 
     * @param file_FileName (optional) 
     * @param siteSurveyId (optional) 
     */
    attachment_Upload(file_ContentType: string | null | undefined, file_ContentDisposition: string | null | undefined, file_Headers: IHeaderDictionary | null | undefined, file_Length: number | undefined, file_Name: string | null | undefined, file_FileName: string | null | undefined, siteSurveyId: string | null | undefined): Promise<SwaggerResponse<CommandResponse>> {
        let url_ = this.baseUrl + "/api/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file_ContentType !== null && file_ContentType !== undefined)
            content_.append("File.ContentType", file_ContentType.toString());
        if (file_ContentDisposition !== null && file_ContentDisposition !== undefined)
            content_.append("File.ContentDisposition", file_ContentDisposition.toString());
        if (file_Headers !== null && file_Headers !== undefined)
            content_.append("File.Headers", JSON.stringify(file_Headers));
        if (file_Length === null || file_Length === undefined)
            throw new Error("The parameter 'file_Length' cannot be null.");
        else
            content_.append("File.Length", file_Length.toString());
        if (file_Name !== null && file_Name !== undefined)
            content_.append("File.Name", file_Name.toString());
        if (file_FileName !== null && file_FileName !== undefined)
            content_.append("File.FileName", file_FileName.toString());
        if (siteSurveyId !== null && siteSurveyId !== undefined)
            content_.append("SiteSurveyId", siteSurveyId.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachment_Upload(_response);
        });
    }

    protected processAttachment_Upload(response: Response): Promise<SwaggerResponse<CommandResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CommandResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Upload multiple files
     * @param files (optional) 
     * @param siteSurveyId (optional) 
     */
    attachment_UploadMultiple(files: FileParameter[] | null | undefined, siteSurveyId: string | null | undefined): Promise<SwaggerResponse<CommandResponse2>> {
        let url_ = this.baseUrl + "/api/Attachment/Multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (siteSurveyId !== null && siteSurveyId !== undefined)
            content_.append("SiteSurveyId", siteSurveyId.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachment_UploadMultiple(_response);
        });
    }

    protected processAttachment_UploadMultiple(response: Response): Promise<SwaggerResponse<CommandResponse2>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CommandResponse2>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all definitions
     */
    definition_GetAll(): Promise<SwaggerResponse<DefinitionSummaryModel[]>> {
        let url_ = this.baseUrl + "/api/Definition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDefinition_GetAll(_response);
        });
    }

    protected processDefinition_GetAll(response: Response): Promise<SwaggerResponse<DefinitionSummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DefinitionSummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Create a definition
     */
    definition_Create(command: CreateDefinitionCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/Definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDefinition_Create(_response);
        });
    }

    protected processDefinition_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get a definition by id
     */
    definition_Get(id: string | null): Promise<SwaggerResponse<DefinitionModel>> {
        let url_ = this.baseUrl + "/api/Definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDefinition_Get(_response);
        });
    }

    protected processDefinition_Get(response: Response): Promise<SwaggerResponse<DefinitionModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DefinitionModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update a definition
     */
    definition_Update(id: string | null, command: UpdateDefinitionCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDefinition_Update(_response);
        });
    }

    protected processDefinition_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Soft-delete a definition
     */
    definition_Delete(id: string | null): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Definition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDefinition_Delete(_response);
        });
    }

    protected processDefinition_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get audit history of a definition by id
     */
    definition_GetAuditHistory(id: string | null): Promise<SwaggerResponse<DefinitionAuditModel[]>> {
        let url_ = this.baseUrl + "/api/Definition/{id}/AuditHistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDefinition_GetAuditHistory(_response);
        });
    }

    protected processDefinition_GetAuditHistory(response: Response): Promise<SwaggerResponse<DefinitionAuditModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DefinitionAuditModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) Definition Name
     */
    definition_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/Definition/Search?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDefinition_Search(_response);
        });
    }

    protected processDefinition_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all labor types
     */
    laborType_GetAll(): Promise<SwaggerResponse<LaborTypeSummaryModel[]>> {
        let url_ = this.baseUrl + "/api/LaborType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLaborType_GetAll(_response);
        });
    }

    protected processLaborType_GetAll(response: Response): Promise<SwaggerResponse<LaborTypeSummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LaborTypeSummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Create a labor type
     */
    laborType_Create(command: CreateLaborTypeCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/LaborType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLaborType_Create(_response);
        });
    }

    protected processLaborType_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get a labor type by id
     */
    laborType_Get(id: string | null): Promise<SwaggerResponse<LaborTypeModel>> {
        let url_ = this.baseUrl + "/api/LaborType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLaborType_Get(_response);
        });
    }

    protected processLaborType_Get(response: Response): Promise<SwaggerResponse<LaborTypeModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LaborTypeModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update a labor type
     */
    laborType_Update(id: string | null, command: UpdateLaborTypeCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/LaborType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLaborType_Update(_response);
        });
    }

    protected processLaborType_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Soft-delete a labor type
     */
    laborType_Delete(id: string | null): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/LaborType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLaborType_Delete(_response);
        });
    }

    protected processLaborType_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get audit history of a labor type by id
     */
    laborType_GetAuditHistory(id: string | null): Promise<SwaggerResponse<LaborTypeAuditModel[]>> {
        let url_ = this.baseUrl + "/api/LaborType/{id}/AuditHistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLaborType_GetAuditHistory(_response);
        });
    }

    protected processLaborType_GetAuditHistory(response: Response): Promise<SwaggerResponse<LaborTypeAuditModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LaborTypeAuditModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) LaborType Name
     */
    laborType_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/LaborType/Search?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLaborType_Search(_response);
        });
    }

    protected processLaborType_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all records
     */
    maintenanceSchedule_GetAll(): Promise<SwaggerResponse<MaintenanceScheduleSummaryModel[]>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_GetAll(_response);
        });
    }

    protected processMaintenanceSchedule_GetAll(response: Response): Promise<SwaggerResponse<MaintenanceScheduleSummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MaintenanceScheduleSummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get an item by id
     */
    maintenanceSchedule_Get(id: string | null): Promise<SwaggerResponse<MaintenanceScheduleModel>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_Get(_response);
        });
    }

    protected processMaintenanceSchedule_Get(response: Response): Promise<SwaggerResponse<MaintenanceScheduleModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MaintenanceScheduleModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update an item
     */
    maintenanceSchedule_Update(id: string | null, command: UpdateMaintenanceScheduleCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_Update(_response);
        });
    }

    protected processMaintenanceSchedule_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Soft-delete an item
     */
    maintenanceSchedule_Delete(id: string | null): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_Delete(_response);
        });
    }

    protected processMaintenanceSchedule_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get an item by id
     */
    maintenanceSchedule_GetFlatList(id: string | null): Promise<SwaggerResponse<MaintenanceScheduleFlatListModel>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule/{id}/FlatList";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_GetFlatList(_response);
        });
    }

    protected processMaintenanceSchedule_GetFlatList(response: Response): Promise<SwaggerResponse<MaintenanceScheduleFlatListModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MaintenanceScheduleFlatListModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Create an item
     */
    maintenanceSchedule_Create(command: GenerateMaintenanceScheduleCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_Create(_response);
        });
    }

    protected processMaintenanceSchedule_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param siteSurveyId (optional) Id of the site survey that owns the schedule(s)
     * @param nameFilter (optional) MaintenanceSchedule Name
     */
    maintenanceSchedule_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, siteSurveyId: string | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule/Search?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (siteSurveyId !== undefined && siteSurveyId !== null)
            url_ += "SiteSurveyId=" + encodeURIComponent("" + siteSurveyId) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_Search(_response);
        });
    }

    protected processMaintenanceSchedule_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get audit history of an item by id
     */
    maintenanceSchedule_GetAuditHistory(id: string | null): Promise<SwaggerResponse<MaintenanceScheduleAuditModel[]>> {
        let url_ = this.baseUrl + "/api/MaintenanceSchedule/{id}/AuditHistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSchedule_GetAuditHistory(_response);
        });
    }

    protected processMaintenanceSchedule_GetAuditHistory(response: Response): Promise<SwaggerResponse<MaintenanceScheduleAuditModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MaintenanceScheduleAuditModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all records
     */
    maintenanceSheet_GetAll(): Promise<SwaggerResponse<MaintenanceSheetSummaryModel[]>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_GetAll(_response);
        });
    }

    protected processMaintenanceSheet_GetAll(response: Response): Promise<SwaggerResponse<MaintenanceSheetSummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MaintenanceSheetSummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get an item by id
     */
    maintenanceSheet_Get(id: string | null): Promise<SwaggerResponse<MaintenanceSheetModel>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_Get(_response);
        });
    }

    protected processMaintenanceSheet_Get(response: Response): Promise<SwaggerResponse<MaintenanceSheetModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MaintenanceSheetModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update an item
     */
    maintenanceSheet_Update(id: string | null, command: UpdateMaintenanceSheetCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_Update(_response);
        });
    }

    protected processMaintenanceSheet_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Soft-delete an item
     */
    maintenanceSheet_Delete(id: string | null): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_Delete(_response);
        });
    }

    protected processMaintenanceSheet_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Generate an item
     */
    maintenanceSheet_Create(command: GenerateMaintenanceSheetCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_Create(_response);
        });
    }

    protected processMaintenanceSheet_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Complete an item
     */
    maintenanceSheet_Fulfill(id: string | null, command: FulfillMaintenanceSheetCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/{id}/Fulfillment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_Fulfill(_response);
        });
    }

    protected processMaintenanceSheet_Fulfill(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Complete an item
     */
    maintenanceSheet_Complete(id: string | null, command: CompleteMaintenanceSheetCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/{id}/Completion";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_Complete(_response);
        });
    }

    protected processMaintenanceSheet_Complete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param maintenanceScheduleId (optional) Id of the maintenance schedule that the sheets are generated from
     * @param nameFilter (optional) MaintenanceSheet Name
     */
    maintenanceSheet_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, maintenanceScheduleId: string | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/Search?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (maintenanceScheduleId !== undefined && maintenanceScheduleId !== null)
            url_ += "MaintenanceScheduleId=" + encodeURIComponent("" + maintenanceScheduleId) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_Search(_response);
        });
    }

    protected processMaintenanceSheet_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get audit history of an item by id
     */
    maintenanceSheet_GetAuditHistory(id: string | null): Promise<SwaggerResponse<MaintenanceSheetAuditModel[]>> {
        let url_ = this.baseUrl + "/api/MaintenanceSheet/{id}/AuditHistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMaintenanceSheet_GetAuditHistory(_response);
        });
    }

    protected processMaintenanceSheet_GetAuditHistory(response: Response): Promise<SwaggerResponse<MaintenanceSheetAuditModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MaintenanceSheetAuditModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all records
     */
    recommissionSheet_GetAll(): Promise<SwaggerResponse<RecommissionSheetSummaryModel[]>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_GetAll(_response);
        });
    }

    protected processRecommissionSheet_GetAll(response: Response): Promise<SwaggerResponse<RecommissionSheetSummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecommissionSheetSummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get an item by id
     */
    recommissionSheet_Get(id: string | null): Promise<SwaggerResponse<RecommissionSheetModel>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_Get(_response);
        });
    }

    protected processRecommissionSheet_Get(response: Response): Promise<SwaggerResponse<RecommissionSheetModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecommissionSheetModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update an item
     */
    recommissionSheet_Update(id: string | null, command: UpdateRecommissionSheetCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_Update(_response);
        });
    }

    protected processRecommissionSheet_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Soft-delete an item
     */
    recommissionSheet_Delete(id: string | null): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_Delete(_response);
        });
    }

    protected processRecommissionSheet_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Generate an item
     */
    recommissionSheet_Create(command: GenerateRecommissionSheetCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_Create(_response);
        });
    }

    protected processRecommissionSheet_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Complete an item
     */
    recommissionSheet_Fulfill(id: string | null, command: FulfillRecommissionSheetCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/{id}/Fulfillment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_Fulfill(_response);
        });
    }

    protected processRecommissionSheet_Fulfill(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Complete an item
     */
    recommissionSheet_Complete(id: string | null, command: CompleteRecommissionSheetCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/{id}/Completion";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_Complete(_response);
        });
    }

    protected processRecommissionSheet_Complete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param siteSurveyId (optional) Id of the site survey that the sheets are generated from
     * @param nameFilter (optional) RecommissionSheet Name
     */
    recommissionSheet_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, siteSurveyId: string | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/Search?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (siteSurveyId !== undefined && siteSurveyId !== null)
            url_ += "SiteSurveyId=" + encodeURIComponent("" + siteSurveyId) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_Search(_response);
        });
    }

    protected processRecommissionSheet_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get audit history of an item by id
     */
    recommissionSheet_GetAuditHistory(id: string | null): Promise<SwaggerResponse<RecommissionSheetAuditModel[]>> {
        let url_ = this.baseUrl + "/api/RecommissionSheet/{id}/AuditHistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecommissionSheet_GetAuditHistory(_response);
        });
    }

    protected processRecommissionSheet_GetAuditHistory(response: Response): Promise<SwaggerResponse<RecommissionSheetAuditModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecommissionSheetAuditModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all site records
     */
    site_GetAll(): Promise<SwaggerResponse<SiteSummaryModel[]>> {
        let url_ = this.baseUrl + "/api/Site";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSite_GetAll(_response);
        });
    }

    protected processSite_GetAll(response: Response): Promise<SwaggerResponse<SiteSummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteSummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Create a Site
     */
    site_Create(command: CreateSiteCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/Site";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSite_Create(_response);
        });
    }

    protected processSite_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get an item by id
     */
    site_Get(id: string | null): Promise<SwaggerResponse<SiteModel>> {
        let url_ = this.baseUrl + "/api/Site/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSite_Get(_response);
        });
    }

    protected processSite_Get(response: Response): Promise<SwaggerResponse<SiteModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update an item
     */
    site_Update(id: string | null, command: UpdateSiteCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Site/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSite_Update(_response);
        });
    }

    protected processSite_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Soft-delete an item
     */
    site_Delete(id: string | null): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Site/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSite_Delete(_response);
        });
    }

    protected processSite_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) SiteSurvey Name
     */
    site_Search(start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/Site/Search?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSite_Search(_response);
        });
    }

    protected processSite_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all records
     */
    siteSurvey_GetAll(): Promise<SwaggerResponse<SiteSurveySummaryModel[]>> {
        let url_ = this.baseUrl + "/api/SiteSurvey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_GetAll(_response);
        });
    }

    protected processSiteSurvey_GetAll(response: Response): Promise<SwaggerResponse<SiteSurveySummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteSurveySummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Create an item
     */
    siteSurvey_Create(command: CreateSiteSurveyCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/SiteSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Create(_response);
        });
    }

    protected processSiteSurvey_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get an item by id
     */
    siteSurvey_Get(id: string | null): Promise<SwaggerResponse<SiteSurveyModel>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Get(_response);
        });
    }

    protected processSiteSurvey_Get(response: Response): Promise<SwaggerResponse<SiteSurveyModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteSurveyModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update an item
     */
    siteSurvey_Update(id: string | null, command: UpdateSiteSurveyCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Update(_response);
        });
    }

    protected processSiteSurvey_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get a preview of the recommission sheet for a given survey
     */
    siteSurvey_GetRecommissionSheetFlatListPreview(id: string | null): Promise<SwaggerResponse<SiteSurveyRecommissionSheetPreviewModel>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}/RecommissionSheetPreview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_GetRecommissionSheetFlatListPreview(_response);
        });
    }

    protected processSiteSurvey_GetRecommissionSheetFlatListPreview(response: Response): Promise<SwaggerResponse<SiteSurveyRecommissionSheetPreviewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteSurveyRecommissionSheetPreviewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all the node locations in the survey
     */
    siteSurvey_GetPaths(id: string | null): Promise<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}/Path";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_GetPaths(_response);
        });
    }

    protected processSiteSurvey_GetPaths(response: Response): Promise<SwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get all the node summary in the survey
     */
    siteSurvey_GetNodeSummaryList(id: string | null): Promise<SwaggerResponse<NodeSummary[]>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}/NodeSummaryList";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_GetNodeSummaryList(_response);
        });
    }

    protected processSiteSurvey_GetNodeSummaryList(response: Response): Promise<SwaggerResponse<NodeSummary[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NodeSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Clone an item
     */
    siteSurvey_Clone(command: CloneSiteSurveyCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/Clone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Clone(_response);
        });
    }

    protected processSiteSurvey_Clone(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Complete an item
     */
    siteSurvey_Complete(id: string | null, command: CompleteSiteSurveyCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}/Completion";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Complete(_response);
        });
    }

    protected processSiteSurvey_Complete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update an item
     */
    siteSurvey_Fulfill(id: string | null, command: FulfillSiteSurveyCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}/Fulfill";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Fulfill(_response);
        });
    }

    protected processSiteSurvey_Fulfill(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param siteId (optional) The site identifier.
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     * @param nameFilter (optional) SiteSurvey Name
     */
    siteSurvey_Search(siteId: string | null | undefined, start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined, nameFilter: string | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/Search?";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Search(_response);
        });
    }

    protected processSiteSurvey_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Soft-delete an item
     * @param siteId (optional) 
     */
    siteSurvey_Delete(siteId: string | null | undefined, siteSurveyId: string | null): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{siteSurveyId}?";
        if (siteSurveyId === undefined || siteSurveyId === null)
            throw new Error("The parameter 'siteSurveyId' must be defined.");
        url_ = url_.replace("{siteSurveyId}", encodeURIComponent("" + siteSurveyId));
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_Delete(_response);
        });
    }

    protected processSiteSurvey_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get audit history of an item by id
     */
    siteSurvey_GetAuditHistory(id: string | null): Promise<SwaggerResponse<SiteSurveyAuditModel[]>> {
        let url_ = this.baseUrl + "/api/SiteSurvey/{id}/AuditHistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSiteSurvey_GetAuditHistory(_response);
        });
    }

    protected processSiteSurvey_GetAuditHistory(response: Response): Promise<SwaggerResponse<SiteSurveyAuditModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SiteSurveyAuditModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Validate that the user account is valid and return an auth token
    to the requesting app for use in the api.
     */
    user_Authenticate(command: AuthenticateCommand): Promise<SwaggerResponse<TokenResponse>> {
        let url_ = this.baseUrl + "/api/User/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_Authenticate(_response);
        });
    }

    protected processUser_Authenticate(response: Response): Promise<SwaggerResponse<TokenResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TokenResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Validate that the user account is valid and return an auth token
    to the requesting app for use in the api.
     */
    user_RefreshToken(command: RefreshTokenCommand): Promise<SwaggerResponse<TokenResponse>> {
        let url_ = this.baseUrl + "/api/User/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_RefreshToken(_response);
        });
    }

    protected processUser_RefreshToken(response: Response): Promise<SwaggerResponse<TokenResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TokenResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Get all
     */
    user_GetAll(): Promise<SwaggerResponse<UserSummaryModel[]>> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_GetAll(_response);
        });
    }

    protected processUser_GetAll(response: Response): Promise<SwaggerResponse<UserSummaryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserSummaryModel[]>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Create a user
     */
    user_Create(command: CreateUserCommand): Promise<SwaggerResponse<CreateResponse>> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_Create(_response);
        });
    }

    protected processUser_Create(response: Response): Promise<SwaggerResponse<CreateResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <CreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result201);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Update a user.
    Only admin can update a user.
     */
    user_Update(id: string | null, command: UpdateUserCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_Update(_response);
        });
    }

    protected processUser_Update(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Get an item by id
     */
    user_Get(id: string | null): Promise<SwaggerResponse<UserModel>> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_Get(_response);
        });
    }

    protected processUser_Get(response: Response): Promise<SwaggerResponse<UserModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserModel>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Deactivate/Soft-delete a user
     */
    user_Delete(id: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_Delete(_response);
        });
    }

    protected processUser_Delete(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Search
     * @param filter (optional) Filter
     * @param start (optional) Starting page
     * @param pageSize (optional) Page Size
     * @param sortColumn (optional) Sort by Column
     * @param sortDirection (optional) Sort direction
     */
    user_Search(filter: string | null | undefined, start: number | undefined, pageSize: number | undefined, sortColumn: string | null | undefined, sortDirection: SortDirection | null | undefined): Promise<SwaggerResponse<DataTablesResponse>> {
        let url_ = this.baseUrl + "/api/User/Search?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_Search(_response);
        });
    }

    protected processUser_Search(response: Response): Promise<SwaggerResponse<DataTablesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DataTablesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * SetPassword for the first time with token
     */
    user_SetPassword(command: SetPasswordCommand): Promise<SwaggerResponse<IdentityResult>> {
        let url_ = this.baseUrl + "/api/User/SetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_SetPassword(_response);
        });
    }

    protected processUser_SetPassword(response: Response): Promise<SwaggerResponse<IdentityResult>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IdentityResult>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<IdentityResult>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * ChangePassword
     */
    user_ChangePassword(command: ChangePasswordCommand): Promise<SwaggerResponse<IdentityResult>> {
        let url_ = this.baseUrl + "/api/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_ChangePassword(_response);
        });
    }

    protected processUser_ChangePassword(response: Response): Promise<SwaggerResponse<IdentityResult>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IdentityResult>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<IdentityResult>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * Allow the user to request an email with password reset link.
     */
    user_ForgotPassword(command: ForgotPasswordCommand): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/User/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_ForgotPassword(_response);
        });
    }

    protected processUser_ForgotPassword(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * ResetPassword
     */
    user_ResetPassword(command: ResetPasswordCommand): Promise<SwaggerResponse<IdentityResult>> {
        let url_ = this.baseUrl + "/api/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUser_ResetPassword(_response);
        });
    }

    protected processUser_ResetPassword(response: Response): Promise<SwaggerResponse<IdentityResult>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IdentityResult>JSON.parse(_responseText, this.jsonParseReviver);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<IdentityResult>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

/** Command Response */
export interface CommandResponse {
    /** Attachment that is uploaded
             */
    resource?: UploadedAttachment | undefined;
}

/** Uploaded attachment */
export interface UploadedAttachment {
    /** Full path to file
             */
    filePath?: string | undefined;
    /** The attachment meta data
             */
    attachment?: Attachment | undefined;
}

export interface Attachment {
    uniqueCode: string;
    fileName?: string | undefined;
    fileType?: string | undefined;
    filePath?: string | undefined;
    originalFileName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
}

export interface IHeaderDictionary {
    Item?: string[];
    ContentLength?: number | undefined;
}

/** Command Response */
export interface CommandResponse2 {
    /** Attachments uploaded
             */
    uploadedAttachments?: UploadedAttachment[] | undefined;
}

/** API model for definition summary */
export interface DefinitionSummaryModel {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
}

/** API model for definition */
export interface DefinitionModel {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Questions
             */
    questions: Question[];
    /** A list of maintenance items for the definition
             */
    maintenanceItems: MaintenanceItem[];
    /** A list of recommission items for the definition
             */
    recommissionItems: RecommissionItem[];
}

export interface Question {
    uniqueCode: string;
    position: number;
    label: string;
    instruction?: string | undefined;
    questionType: QuestionType;
    required?: boolean;
    options: string[];
    answer?: string | undefined;
    attachments?: Attachment[] | undefined;
}

export type QuestionType = "Text" | "Number" | "Date" | "SingleChoice" | "MultipleChoice" | "MultiLineText" | "Attachment" | "Checkbox";

export interface MaintenanceItem {
    uniqueCode: string;
    name: string;
    numberOfMinutesRequired: number;
    maintenanceInterval: MaintenanceInterval;
    isAttachmentRequired: boolean;
    task?: string | undefined;
    cost?: string | undefined;
    laborType?: LaborTypeSnapshot | undefined;
    action?: MaintenanceItemAction | undefined;
}

export type MaintenanceInterval = "Quarterly" | "Spring" | "Summer" | "Fall" | "Winter";

export interface LaborTypeSnapshot {
    id: string;
    name: string;
    rate: number;
}

export interface MaintenanceItemAction {
    isCompleted?: boolean;
    isExtraWorkRequired?: boolean;
    extraWorkItem?: string | undefined;
    notes?: string | undefined;
    attachments?: Attachment[] | undefined;
}

export interface RecommissionItem {
    uniqueCode: string;
    name: string;
    isAttachmentRequired: boolean;
    task?: string | undefined;
    cost?: string | undefined;
    action?: RecommissionItemAction | undefined;
}

export interface RecommissionItemAction {
    findings?: string | undefined;
    changedToSpec?: string | undefined;
    notes?: string | undefined;
    attachments?: Attachment[] | undefined;
}

/** Create response */
export interface CreateResponse {
    /** Id of created item */
    id?: string | undefined;
}

/** Model to create a new Definition */
export interface CreateDefinitionCommand {
    /** Name
             */
    name: string;
    /** Questions
             */
    questions: Question[];
    /** Maintenance Items
             */
    maintenanceItems: MaintenanceItem[];
    /** Recommission Items
             */
    recommissionItems: RecommissionItem[];
}

/** Model to Update a new Component Difinition */
export interface UpdateDefinitionCommand {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Questions
             */
    questions: Question[];
    /** Maintenance Items
             */
    maintenanceItems: MaintenanceItem[];
    /** Recommission Items
             */
    recommissionItems: RecommissionItem[];
}

export interface DefinitionAuditModel {
    definitionModel?: DefinitionModel | undefined;
    dateCreatedUTC?: Date;
    createdBy?: string;
}

export interface DataTablesResponse {
    /** Total number of records available
             */
    totalRecords: number;
    /** Data object
             */
    data: any;
    /** Current page index 
             */
    page: number;
}

export type SortDirection = "Ascending" | "Descending";

/** API model for summary */
export interface LaborTypeSummaryModel {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** LaborType Description
             */
    description: string;
    /** $ rate of the labor type
             */
    rate: number;
}

/** API model */
export interface LaborTypeModel {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** LaborType Description
             */
    description: string;
    /** $ rate of the labor type
             */
    rate: number;
}

/** Model to create a new LaborType */
export interface CreateLaborTypeCommand {
    /** Name
             */
    name: string;
    /** LaborType Description
             */
    description?: string | undefined;
    /** $ rate of the labor type
             */
    rate?: number;
}

/** Model to Update */
export interface UpdateLaborTypeCommand {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** LaborType Description
             */
    description?: string | undefined;
    /** $ rate of the labor type
             */
    rate?: number;
}

export interface LaborTypeAuditModel {
    laborTypeModel?: LaborTypeModel | undefined;
    dateCreatedUTC?: Date;
    createdBy?: string;
}

/**  */
export interface MaintenanceScheduleSummaryModel {
    /** Id
             */
    id: string;
    /** Id of the site survey that owns the schedule.
             */
    ResourceOwnerId: string;
    /** Name
             */
    name: string;
}

/**  */
export interface MaintenanceScheduleModel {
    /** Id
             */
    id: string;
    /** Id of the site survey that owns the schedule.
             */
    ResourceOwnerId: string;
    /** Name
             */
    name: string;
    /** Definition/devices and their associated maintenance items.
             */
    maintenanceScheduleItems: MaintenanceScheduleNode[];
}

export interface MaintenanceScheduleNode {
    location: string;
    uniqueCode: string;
    displayName: string;
    definition: DefinitionSnapshotWithMaintenanceItemsOnly;
}

export interface DefinitionSnapshot {
    id: string;
    name: string;
    questions: Question[];
    maintenanceItems: MaintenanceItem[];
    recommissionItems: RecommissionItem[];
}

export interface DefinitionSnapshotWithMaintenanceItemsOnly extends DefinitionSnapshot {
    id: string;
    name: string;
    maintenanceItems: MaintenanceItem[];
}

/**  */
export interface MaintenanceScheduleFlatListModel {
    /** Id
             */
    id: string;
    /** Id of the site survey that owns the schedule.
             */
    ResourceOwnerId: string;
    /** Name
             */
    name: string;
    /** Flattened Maintenance Items on the sheet
             */
    maintenanceSheetItems: MaintenanceSheetItem[];
}

export interface MaintenanceSheetItem {
    nodeUniqueCode: string;
    location: string;
    maintenanceItem: MaintenanceItem;
}

/** Model to create */
export interface GenerateMaintenanceScheduleCommand {
    /** MaintenanceSchedule Name
             */
    name?: string | undefined;
    /** Id of the site survey that owns the schedule.
             */
    siteSurveyId: string;
}

/** Model to Update */
export interface UpdateMaintenanceScheduleCommand {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Definition/devices and their associated maintenance items.
When generating these items or CRUD these items, items should be grouped by their parent (definition node).
When completing a maintenance schedule on a maintenance sheet, these items can be further flattened into just a list grouped by interval.
             */
    maintenanceScheduleItems?: MaintenanceScheduleNode[] | undefined;
}

export interface MaintenanceScheduleAuditModel {
    maintenanceScheduleModel?: MaintenanceScheduleModel | undefined;
    dateCreatedUTC?: Date;
    createdBy?: string;
}

/** API model */
export interface MaintenanceSheetSummaryModel {
    /** Id
             */
    id: string;
    /** Name of the sheet.
E.g., 2021 Fall CostcoABC.
             */
    name: string;
    /** Id of the owner.
E.g. maintenance schedule id that owns the maintenance sheet.
             */
    ResourceOwnerId: string;
    /** Status. E.g. whether the maintenance sheet is completed by a technician
             */
    maintenanceSheetStatus?: MaintenanceSheetStatus;
    /** A list of users, most likely technicians, assigned to the sheet
             */
    users?: UserSummaryModel[] | undefined;
}

export type MaintenanceSheetStatus = "New" | "Completed";

/** API model for user summary */
export interface UserSummaryModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    isEnabled?: boolean;
}

/** API model */
export interface MaintenanceSheetModel {
    /** Id
             */
    id: string;
    /** Name of the sheet.
E.g., 2021 Fall CostcoABC.
             */
    name: string;
    /** Id of the owner.
E.g. maintenance schedule id that owns the maintenance sheet.
             */
    ResourceOwnerId: string;
    /** Flattened Maintenance Items on the sheet
             */
    items: MaintenanceSheetItem[];
    /** Status. E.g. whether the maintenance sheet is completed by a technician
             */
    maintenanceSheetStatus?: MaintenanceSheetStatus;
    /** A list of users, most likely technicians, assigned to the sheet
             */
    users?: UserSummaryModel[] | undefined;
}

/** Model to create */
export interface GenerateMaintenanceSheetCommand {
    /** Maintenance Sheet Name
             */
    name?: string | undefined;
    /** Id of the maintenance schedule that owns the sheet
             */
    maintenanceScheduleId: string;
}

/** Model to Update */
export interface UpdateMaintenanceSheetCommand {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Flattened Maintenance Items on the sheet
             */
    items?: MaintenanceSheetItem[] | undefined;
    /** A list of users, most likely technicians, assigned to the sheet
             */
    users?: UserSummaryModel[] | undefined;
}

/** Model to Fulfill */
export interface FulfillMaintenanceSheetCommand {
    /** Id
             */
    id: string;
    /** Flattened Maintenance Items on the sheet
             */
    items?: MaintenanceSheetItem[] | undefined;
}

/** Model to Complete */
export interface CompleteMaintenanceSheetCommand {
    /** Id
             */
    id: string;
}

export interface MaintenanceSheetAuditModel {
    maintenanceSheetModel?: MaintenanceSheetModel | undefined;
    dateCreatedUTC?: Date;
    createdBy?: string;
}

/** API model */
export interface RecommissionSheetSummaryModel {
    /** Id
             */
    id: string;
    /** Name of the sheet.
E.g., 2021 Fall CostcoABC.
             */
    name: string;
    /** Id of the owner.
E.g. site survey id that owns the recommission sheet.
             */
    ResourceOwnerId: string;
    /** Status. E.g. whether the sheet is completed by a technician
             */
    recommissionSheetStatus?: RecommissionSheetStatus;
    /** A list of users, most likely technicians, assigned to the sheet
             */
    users?: UserSummaryModel[] | undefined;
}

export type RecommissionSheetStatus = "New" | "Completed";

/** API model */
export interface RecommissionSheetModel {
    /** Id
             */
    id: string;
    /** Name of the sheet
             */
    name: string;
    /** Id of the owner.
E.g. site survey id that owns the recommission sheet.
             */
    ResourceOwnerId: string;
    /** Flattened Recommission Items on the sheet
             */
    recommissionSheetItems: RecommissionSheetItem[];
    /** Status. E.g. whether the maintenance sheet is completed by a technician
             */
    recommissionSheetStatus?: RecommissionSheetStatus;
    /** A list of users, most likely technicians, assigned to the sheet
             */
    users?: UserSummaryModel[] | undefined;
}

export interface RecommissionSheetItem {
    nodeUniqueCode: string;
    location: string;
    recommissionItem: RecommissionItem;
}

/** Model to create */
export interface GenerateRecommissionSheetCommand {
    /** Recommission Sheet Name
             */
    name?: string | undefined;
    /** Id of the site survey that owns the sheet
             */
    siteSurveyId: string;
}

/** Model to Update */
export interface UpdateRecommissionSheetCommand {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Flattened Recommission Items on the sheet
             */
    recommissionSheetItems?: RecommissionSheetItem[] | undefined;
    /** A list of users, most likely technicians, assigned to the sheet
             */
    users?: UserSummaryModel[] | undefined;
}

/** Model to Fulfill */
export interface FulfillRecommissionSheetCommand {
    /** Id
             */
    id: string;
    /** Flattened Recommission Items on the sheet
             */
    items?: RecommissionSheetItem[] | undefined;
}

/** Model to Complete */
export interface CompleteRecommissionSheetCommand {
    /** Id
             */
    id: string;
}

export interface RecommissionSheetAuditModel {
    recommissionSheetModel?: RecommissionSheetModel | undefined;
    dateCreatedUTC?: Date;
    createdBy?: string;
}

/** API model for site survey summary */
export interface SiteSummaryModel {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
}

/** API Model */
export interface SiteModel {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Site Description
             */
    description?: string | undefined;
    /** SiteSurvey for a site 
             */
    siteSurvey?: SiteSurvey[] | undefined;
}

export interface BaseEntity {
    id?: string | undefined;
    entityStatus?: EntityStatus;
    dateCreatedUTC?: Date;
    dateModifiedUTC?: Date;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
}

export interface SiteSurvey extends BaseEntity {
    metaType?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    siteId?: string | undefined;
    node?: Node | undefined;
    siteSurveyStatus?: SiteSurveyStatus;
}

export interface Node {
    uniqueCode: string;
    displayName: string;
    definition: DefinitionSnapshot;
    children: Node[];
}

export type SiteSurveyStatus = "New" | "Completed";

export type EntityStatus = "Active" | "Deleted";

/** Model to create */
export interface CreateSiteCommand {
    /** Site Name
             */
    name: string;
    /** Site Description
             */
    description?: string | undefined;
}

/** Model to Update a new Component Difinition */
export interface UpdateSiteCommand {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Site Description
             */
    description?: string | undefined;
    /** SiteSurvey for a site 
             */
    siteSurvey?: SiteSurvey[] | undefined;
}

/** API model for site survey summary */
export interface SiteSurveySummaryModel {
    /** Id
             */
    id: string;
    /** Name
             */
    name: string;
    /** Status. E.g. whether the survey is completed by a technician.
When marking the status as completed, the system will validate all the questions and make sure all required questions have an answer.
             */
    siteSurveyStatus: SiteSurveyStatus;
}

/** API Model */
export interface SiteSurveyModel {
    /** Id
             */
    siteSurveyId: string;
    /** Name
             */
    name: string;
    /** Questions
             */
    node: Node;
    /** Status. E.g. whether the survey is completed by a technician.
When marking the status as completed, the system will validate all the questions and make sure all required questions have an answer.
             */
    siteSurveyStatus: SiteSurveyStatus;
}

/** Preview of the recommission sheet for a site survey */
export interface SiteSurveyRecommissionSheetPreviewModel {
    /** Survey Id
             */
    id: string;
    /** Meta Type, which will be used as the partition key
             */
    metaType: string;
    /** Survey Name
             */
    name: string;
    /** Flattened Recommission Items on the sheet
             */
    recommissionSheetItems: RecommissionSheetItem[];
}

export interface NodeSummary {
    uniqueCode?: string;
    location?: string | undefined;
}

/** Model to create */
export interface CreateSiteSurveyCommand {
    /** Site Id
             */
    siteId?: string | undefined;
    /** SiteSurvey Name
             */
    name: string;
    /** Site Node is a hierarchical collection of Definitions
             */
    node?: Node | undefined;
}

/** Model to create */
export interface CloneSiteSurveyCommand {
    /** ID of the site to be cloned
             */
    siteId: string;
    /** ID of the site survey to be cloned
             */
    siteSurveyId: string;
    /** New Name
             */
    name: string;
}

/** Model to Update a new Component Difinition */
export interface UpdateSiteSurveyCommand {
    /** Site Id
             */
    siteId?: string | undefined;
    /** Id
             */
    siteSurveyId: string;
    /** Name
             */
    name: string;
    /** Site Node is a hierarchical collection of Definitions
             */
    node?: Node | undefined;
}

/** Model to Complete */
export interface CompleteSiteSurveyCommand {
    /** Id
             */
    id: string;
}

/** Model to Fulfill a new Component Difinition */
export interface FulfillSiteSurveyCommand {
    /** Id
             */
    id: string;
    /** Site Node is a hierarchical collection of Definitions
             */
    node?: Node | undefined;
}

export interface SiteSurveyAuditModel {
    siteSurveyModel?: SiteSurveyModel | undefined;
    dateCreatedUTC?: Date;
    createdBy?: string;
}

export interface TokenResponse {
    id?: string | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    token?: string | undefined;
    role?: string | undefined;
    refreshToken?: string | undefined;
}

export interface TokenRequest {
    username: string;
    password: string;
}

/** command */
export interface AuthenticateCommand extends TokenRequest {
}

/** command */
export interface RefreshTokenCommand {
    /** Refresh token used to retrieve a new JWT token
             */
    refreshToken: string;
}

/** Model to create a new User */
export interface CreateUserCommand {
    /** The account owners First Name.
             */
    firstName: string;
    /** The account owners Last Name.
             */
    lastName: string;
    /** A unique email that the user uses to sign in with.
             */
    email: string;
    /** The Role that the user is being assigned.
             */
    role: string;
}

/** Model to Update */
export interface UpdateUserCommand {
    /** User Id
             */
    id: string;
    /** First name
             */
    firstName: string;
    /** Last Name
             */
    lastName: string;
}

/** API model for user */
export interface UserModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    isEnabled?: boolean;
}

export interface IdentityResult {
    succeeded?: boolean;
    errors?: IdentityError[] | undefined;
}

export interface IdentityError {
    code?: string | undefined;
    description?: string | undefined;
}

/** Model to SetPassword */
export interface SetPasswordCommand {
    /** Email Confirmation Token
             */
    token: string;
    /** Email
             */
    email: string;
    /** Password
             */
    password: string;
}

/** Model to ChangePassword */
export interface ChangePasswordCommand {
    /** User Id
             */
    id: string;
    /** Current
             */
    currentPassword: string;
    /** New
             */
    newPassword: string;
}

/** Model to ForgotPassword */
export interface ForgotPasswordCommand {
    /** Email
             */
    email: string;
}

/** Model to ResetPassword */
export interface ResetPasswordCommand {
    /** Reset pwd Token
             */
    token: string;
    /** Email
             */
    email: string;
    /** Password
             */
    password: string;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// NOTE: Do not include NswagBaseClientTemplate.ts in workspace
/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 * https://github.com/RicoSuter/NSwag/wiki/TypeScriptClientGenerator
 * This is used by the .nswag config file and will be copied into the generated client code
 */
export interface IConfig {
    /**
     * Returns a valid value for the Authorization header.
     * Used to dynamically inject the current auth header.
     */
    token: string | null
}

export interface Attachment {
    uniqueCode: string;
    fileName?: string | undefined;
    fileType?: string | undefined;
    filePath?: string | undefined;
    originalFileName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
}

export interface ValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; } | null;
}